import { Component, OnInit } from '@angular/core';
import {AppConfigService} from '../../../../../app-config.service';
import {GeneralService} from '../../../../service/general-service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../../../service/notification.service';

@Component({
  selector: 'app-doctor-prices',
  templateUrl: './doctor-prices.component.html',
  styleUrls: ['./doctor-prices.component.scss']
})
export class DoctorPricesComponent implements OnInit {
  datas: any[] = [];
  filter = {
    startDate: new Date(),
    endDate: new Date(),
    status: 'all'
  };
  isShowReport = false;
  files: any[] = [];
  partnerInfo: any;
  constructor(
    private configService: AppConfigService,
    private generalService: GeneralService,
    public translate: TranslateService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.generalService.getMyPartnerInfo().subscribe(
      (res) => {
        if (res !== null) {
          console.log(res);
          this.partnerInfo = res;
          this.datas = res.partnerDisplayPrices;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

}
